
<template>
<!-- 区服对比 -->
  <div chass="app-container">
    <div class="chart-container">
      <el-row :gutter="20">
        <el-col :span="24" style="margin-bottom:10px;background:#fff">
          <div class="grid-content" style="float: left;width: 100%;position:relative;">
            <div class="ibox-title" style="float: left;width: 100%;">
              <span style="float:left;">
                <h5>区服对比</h5>
              </span>
              <div class="ibox-tools" style="float:right;">
                <el-tooltip content="指标说明" placement="top">
                  <el-button size="mini" @click="dialogTipsVisible = true">
                    <svg-icon icon-class="ask" />
                  </el-button>
                </el-tooltip>
              </div>
            </div>

            <div>
              <el-select v-model="serverIds" size="mini" multiple collapse-tags filterable style="float:left;margin-left:15px;margin-top:10px;margin-bottom:10px;width:250px" placeholder="全部区服"
                @change="selectmultipleChanne($event, header_server_codeold,qufu_list,serverIds)">
                <el-option v-for="item in qufu_list" :value="item.value" :label="item.key" :key="item.value"></el-option>
              </el-select>
              <el-select v-model="countryIds" size="mini" multiple collapse-tags filterable style="float:left;margin-left:15px;margin-top:10px;margin-bottom:10px;width:250px" placeholder="全部国家"
                @change="countryIdsChanne($event, header_countryIds_codeold,guojia_list,countryIds)">
                <el-option v-for="item in guojia_list" :value="item.code" :label="item.name" :key="item.code"></el-option>
              </el-select>
              <el-radio-group v-model="tiaojian.dayNum" size="mini" style="float:left;margin-left:15px;margin-top:10px;margin-bottom:10px" @change="mohuchaxun">
                <el-radio-button label="7">开服7天</el-radio-button>
                <el-radio-button label="14">开服14天</el-radio-button>
                <el-radio-button label="30">开服30天</el-radio-button>
              </el-radio-group>
              <el-button type="primary" size="mini" @click="mohuchaxun" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px">查询</el-button>

              <!-- :style="{'min-height':'500px'}" -->
              <el-table :data="tableData.page.result" :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'6px 6px !important'}" class="tb-edit" border 
                v-loading="loadding">

                <el-table-column :min-width="itemtable.width" :fixed="itemtable.property=='serverName' || itemtable.property=='countryName' || itemtable.property=='openServerTime'" v-for="itemtable in tableData.thead"
                  show-overflow-tooltip :key="itemtable.label" :label="itemtable.label" :property="itemtable.property">
                  <el-table-column :min-width="itemtable1.width"  v-for="itemtable1 in itemtable.children"
                  show-overflow-tooltip :key="itemtable1.label" :label="itemtable1.label" :property="itemtable1.property"></el-table-column>
                  </el-table-column>

              </el-table>
              <div class="block" style="padding-bottom:10px">
                <el-pagination :current-page="tiaojian.pageNo" :page-sizes="[10,15, 20, 30, 50]" :page-size="tiaojian.pageSize" layout="->,total,sizes,  prev, pager, next, jumper" :pager-count="5" :total="dataLength"
                  style="margin-top:10px;" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
              </div>

            </div>
          </div>
        </el-col>
      </el-row>

    </div>

    <el-dialog title="指标说明" :visible.sync="dialogTipsVisible" width="70%" top="10vh">
      <el-table :data="gridTipsData" border highlight-current-row height="600" class="tips_table">
        <el-table-column property="title" label="指标" width="150"></el-table-column>
        <el-table-column property="content" label="定义"></el-table-column>
        <el-table-column property="desc" label="备注" width="250"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  ajax_handleBusinessByTargetKpi,
  ajax_zitiaojiandata
} from "@Gms~/api/ajax_model";

import FileSaver from "file-saver";
import XLSX from "xlsx";

export default {
  name: "GS_SERVER_CONTRAST",
  components: {},
  data() {
    return {
      qufu_list: [],
      guojia_list: [],
      tiaojian: {
        pageNo: 1, //   (当前页)
        pageSize: 20, //   (每页条数)
        dayNum:"7", //   (查询时间)
        countryIds: "", //(国家id，多个以,分割)
        serverIds: "" //(区服id，多个以,分割)
      },
      countryIds: [], //(国家id，多个以,分割)
      serverIds: [], //(区服id，多个以,分割)
      header_server_codeold: [],
      header_countryIds_codeold: [],
      tableData: {
        page: {
          result: []
        },
        thead: []
      },
      dataLength: 0,
      loadding: false,

      dialogTipsVisible: false,
      gridTipsData: [
        {title:"	开服时间	",content:"	各区服对应的开服时间	",desc:"		"},
{title:"	充值金额	",content:"	该区服、国家在开服第n日当日的付费总金额	",desc:"		"},
{title:"	活跃人数	",content:"	该区服、国家在开服第n日当日有登陆或登出行为的去重角色数	",desc:"		"},
{title:"	平均在线时长	",content:"	该区服、国家在开服第n日当日的总在线时长/当日活跃角色数	",desc:"		"},
{title:"	留存率	",content:"	该区服、国家在开服第1日当日新增的角色中，在该日后第n日的活跃角色数/第1日的新增角色数	",desc:"		"},


      ],
    };
  },
  created() {
    this.tiaojian_handleBusinessByTargetKpi();
    this.zitiaojiandata("", "header_server_code");
    this.list_handleBusinessByTargetKpi();
  },
  mounted() {},
  methods: {
    mohuchaxun() {
      this.list_handleBusinessByTargetKpi();
    },
    tiaojian_handleBusinessByTargetKpi() {
      //国家列表
      ajax_handleBusinessByTargetKpi("gs_1_3_1", {}).then(
        response => {
          console.log("国家列表");
          console.log(response);
          if (response.code == 1) {
            response.data.unshift({ name: "全选", code: "" });
            this.guojia_list = response.data;
          }
        }
      );
    },

    list_handleBusinessByTargetKpi() {
      this.loadding = true;
      this.tiaojian.countryIds = this.countryIds.join(",");
      this.tiaojian.serverIds = this.serverIds.join(",");
      if (this.tiaojian.countryIds.substring(0, 1) == ",") {
        this.tiaojian.countryIds = this.tiaojian.countryIds.substring(
          1,
          this.tiaojian.countryIds.length
        );
      }
      if (this.tiaojian.serverIds.substring(0, 1) == ",") {
        this.tiaojian.serverIds = this.tiaojian.serverIds.substring(
          1,
          this.tiaojian.serverIds.length
        );
      }
      console.log(this.tiaojian);
      //国家列表list
      ajax_handleBusinessByTargetKpi(
        "gs_3_2_1",
        this.tiaojian
      ).then(response => {
        console.log("国家列表");
        console.log(response);
        if (response.code == 1) {
          this.tableData = response.data;
          this.dataLength = response.data.page.totalCount;
        }

        this.loadding = false;
      });
    },
    zitiaojiandata(data, name) {
      ajax_zitiaojiandata(data, name).then(response => {
        console.log(response);
        if (response.code == 1) {
          var datas = response.data;
          if (name == "header_server_code") {
            response.data.unshift({ key: "全选", value: "" });
            this.qufu_list = response.data;
          }
        } else {
          this.$message({
            type: "warning",
            message: response.msg
          });
        }
      });
    },
    handleSizeChange(e) {
      // table 分页数量变化
      this.tiaojian.pageSize = e;
      this.list_handleBusinessByTargetKpi();
    },
    handleCurrentChange(e) {
      // table 分页变化
      this.tiaojian.pageNo = e;
      this.list_handleBusinessByTargetKpi();
    },
    exportExcel(e) {
      /* generate workbook object from table */
      var wb = XLSX.utils.table_to_book(
        document.querySelector("#xiazaishijian")
      );
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "事件列表.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    selectmultipleChanne(e, oldlist, list, val) {
      // select多选
      //变化
      let allValues = [];
      //保留所有值
      for (let item of list) {
        allValues.push(item.value);
      }
      // 用来储存上一次的值，可以进行对比
      const oldVal = oldlist.length === 0 ? [] : oldlist[1];
      // 若是全部选择
      if (val.includes("")) this.serverIds = allValues;
      // 取消全部选中  上次有 当前没有 表示取消全选
      if (oldVal.includes("") && !val.includes("")) this.serverIds = [];
      // 点击非全部选中  需要排除全部选中 以及 当前点击的选项
      // 新老数据都有全部选中
      if (oldVal.includes("") && val.includes("")) {
        const index = val.indexOf("");
        val.splice(index, 1); // 排除全选选项
        this.serverIds = val;
      }
      //全选未选 但是其他选项全部选上 则全选选上 上次和当前 都没有全选
      if (!oldVal.includes("") && !val.includes("")) {
        if (val.length === allValues.length - 1)
          this.serverIds = [""].concat(val);
      }
      //储存当前最后的结果 作为下次的老数据
      oldlist[1] = this.serverIds;
      var sid = [];
      for (var i = 0; i < this.serverIds.length; i++) {
        if (this.serverIds[i] != "") {
          sid.push(this.serverIds[i]);
        }
      }
      console.log(sid);
    },
    countryIdsChanne(e, oldlist, list, val) {
      // select多选
      //变化
      let allValues = [];
      //保留所有值
      for (let item of list) {
        allValues.push(item.code);
      }
      // 用来储存上一次的值，可以进行对比
      const oldVal = oldlist.length === 0 ? [] : oldlist[1];
      // 若是全部选择
      if (val.includes("")) this.countryIds = allValues;
      // 取消全部选中  上次有 当前没有 表示取消全选
      if (oldVal.includes("") && !val.includes("")) this.countryIds = [];
      // 点击非全部选中  需要排除全部选中 以及 当前点击的选项
      // 新老数据都有全部选中
      if (oldVal.includes("") && val.includes("")) {
        const index = val.indexOf("");
        val.splice(index, 1); // 排除全选选项
        this.countryIds = val;
      }
      //全选未选 但是其他选项全部选上 则全选选上 上次和当前 都没有全选
      if (!oldVal.includes("") && !val.includes("")) {
        if (val.length === allValues.length - 1)
          this.countryIds = [""].concat(val);
      }
      //储存当前最后的结果 作为下次的老数据
      oldlist[1] = this.countryIds;
      var sid = [];
      for (var i = 0; i < this.countryIds.length; i++) {
        if (this.countryIds[i] != "") {
          sid.push(this.countryIds[i]);
        }
      }
      console.log(sid);
    },
    handleAgeSortChange(e) {
      console.log(e);
      if (e.order == "ascending") {
        var order = true;
      } else if (e.order == "descending") {
        var order = false;
      }
      if (e.order == null) {
        this.rz_tableData2 = JSON.parse(JSON.stringify(this.rz_tableData2copy));
      } else {
        this.rz_tableData2.tbody.sort(this.sortBy(e.prop, order));
      }
    },
    sortBy(attr, rev) {
      // 第二个参数没有传递 默认升序排列
      if (rev == undefined) {
        rev = 1;
      } else {
        rev = rev ? 1 : -1;
      }

      return function(a, b) {
        // a = a[attr];
        // b = b[attr];
        if (!isNaN(Number(a[attr])) && !isNaN(Number(b[attr]))) {
          a = Number(a[attr]);
          b = Number(b[attr]);
        } else {
          a = a[attr];
          b = b[attr];
        }

        if (a < b) {
          return rev * -1;
        }
        if (a > b) {
          return rev * 1;
        }
        return 0;
      };
    }
  },
  filters: {
    delFlags(value) {
      if (value == "0") {
        return "显示";
      } else if (value == "1") {
        return "隐藏";
      }
    },
    platformTypes(value) {
      if (value == "1") {
        return "服务端事件";
      } else if (value == "2") {
        return "客户端事件";
      }
    },
    eventTypes(value) {
      if (value == "0") {
        return "公共事件";
      } else if (value == "3") {
        return "必传参数";
      } else if (value == "1") {
        return "自定义事件";
      }
    },
    eventDescsub(value) {
      if (value.length > 25) {
        return value.substring(0, 25) + "...";
      } else {
        return value;
      }
    },
    eventNamesub(value) {
      if (value.length > 10) {
        return value.substring(0, 10) + "...";
      } else {
        return value;
      }
    },
    dataEmptys(value) {
      if (value == "0") {
        return "否";
      } else if (value == "1") {
        return "是";
      }
    },
    ispresets(value) {
      if (value == "0") {
        return "否";
      } else if (value == "1") {
        return "是";
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-container {
  background-color: #364652;
}
.chart-container {
  position: relative;
  padding: 10px 15px;
  padding-bottom: 1px;
  /* width: 100%;
    height: 30%; */
  background-color: #f0efef;
}
.ibox-title {
  line-height: 32px;
  padding: 4px 15px 3px;
}

/* .grid-content  */
.ibox-title {
  border-bottom: 1px solid #dedede;
}
.ibox-content {
  border: none;
}
.ibox-title h5 {
  margin: 0;
}
.tb-edit {
  width: 98%;
  margin-left: 1%;
  margin-top: 15px;
  font-size: 12px !important;
}
.tb-edit ::v-deep .el-table__body-wrapper {
  z-index: 1;
}
/* .el-table th{background:#fff;} */
</style>

<style>
.el-dialog__body {
  padding: 10px 5px;
}
.el-tabs__header {
  margin-bottom: 0px;
}
.el-tabs__nav {
  /* margin-left: 30px;
  margin-right: 30px; */
}
.el-row {
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #fff;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 30px;
  /* padding-bottom: 15px; */
}
.row-bg {
  /* padding: 10px 0; */
  background-color: #f9fafc;
}
.tb-edit1 tr td .cell {
  /* padding: 5px 2px !important; */
}

.el-table th {
  background-color: #fff;
}


.el-table.tips_table tr td .cell {
  padding: 6px 2px !important;
  font-size: 12px;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.panel-group {
  // margin-top: 18px;
  .card-panel-col {
    // margin-bottom: 32px;
  }
  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.1);
    border-color: rgba(0, 0, 0, 0.05);
    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }
      .icon-people {
        background: #40c9c6;
      }
      .icon-message {
        background: #36a3f7;
      }
      .icon-money {
        background: #f4516c;
      }
      .icon-shoppingCard {
        background: #34bfa3;
      }
    }
    .icon-people {
      color: #40c9c6;
    }
    .icon-message {
      color: #36a3f7;
    }
    .icon-money {
      color: #f4516c;
    }
    .icon-shoppingCard {
      color: #34bfa3;
    }
    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }
    .card-panel-icon {
      float: left;
      font-size: 48px;
    }
    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }
      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}
</style>
